export const init = () => {
  const checkbox = cube.$id('js-middlename-checkbox');

  checkbox.on('change', toggleMiddleName);
};


/**
 * Enable or disable the middlename field.
 *
 */
function toggleMiddleName () {
  const middlename = cube.$id('middlename');
  const { classList } = middlename.closest('.form-group');

  classList.remove('has-error', 'validated');

  if (this.checked) {
    middlename.value = '';
    middlename.disabled = true; // For create account process //
    middlename.dataset.disabled = '';
    classList.add('account-form__field--disabled');
  }
  else {
    middlename.disabled = false;
    middlename.removeAttribute('data-disabled'); // For create account process //
    classList.remove('account-form__field--disabled');
  }
};



// WEBPACK FOOTER //
// ./src/customer/customer-names.js